import BaseModel from './BaseModel';

export default class SelectFieldOption extends BaseModel {
  constructor(label = '', value = '', selected = false) {
    super();
    /** @type {string} **/
    this.label = label;
    /** @type {string} **/
    this.value = value;
    /** @type {bool} **/
    this.selected = selected;
  }
}
